var map = {
	"./ambassador-bg.webp": 1272,
	"./asset-2.png": 1273,
	"./btn-enter-bg.png": 1274,
	"./btn-enter-white-bg.webp": 1275,
	"./btn-more-bg.webp": 1276,
	"./casino-hover.webp": 1277,
	"./casino.webp": 1278,
	"./convenient.webp": 1279,
	"./es-bg.webp": 1280,
	"./event-sec-bg.webp": 1281,
	"./event-sport-bg.webp": 1282,
	"./fifa1-bg.jpg": 1283,
	"./fifa2-bg-cn.jpg": 1284,
	"./fifa2-bg.jpg": 1285,
	"./games-hover.webp": 1286,
	"./games.webp": 1287,
	"./gauge.webp": 1288,
	"./lottery-hover.webp": 1289,
	"./lottery.webp": 1290,
	"./master-bg.webp": 1291,
	"./p2p-hover.webp": 1292,
	"./p2p.webp": 1293,
	"./platform.webp": 1294,
	"./product-ctg-bg.webp": 1295,
	"./product-overview-bg.webp": 1296,
	"./professional.webp": 1297,
	"./safety.webp": 1298,
	"./slots-hover.webp": 1299,
	"./slots.webp": 1300,
	"./speed.webp": 1301,
	"./sports-hover.webp": 1302,
	"./sports.webp": 1303,
	"./video-bg.webp": 1304,
	"./wave.webp": 1305,
	"./wwr-bg.webp": 1306,
	"./wwr-img-b.webp": 1307,
	"./wwr-img.webp": 1308,
	"./wwr-subImg1.webp": 1309,
	"./wwr-subImg2.webp": 1310,
	"./wwr-subImg3.webp": 1311,
	"./x33-logo-cny.png": 1312
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 462;